import React , {useState, useEffect}from 'react'; // ✅ useEffect इम्पोर्ट करें
import { Container, Form, Button, Row, Col, Card, Spinner } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// faEnvelope, faLock, faUser की यहां आवश्यकता नहीं है
import { faCheckCircle } from '@fortawesome/free-solid-svg-icons'; // ✅ सफलता आइकन इम्पोर्ट करें
import { useDispatch,useSelector } from 'react-redux';
import { useNavigate,Link, useParams, useLocation } from 'react-router-dom';
// loginUser, signIn, verifySignup, loginSuccess की यहां आवश्यकता नहीं है


const VerifyOtpSuccess = () => {
  const navigate = useNavigate();
  const location = useLocation(); // यदि आपको location.state से कोई डेटा चाहिए
  
  useEffect(() => {
    // 3 सेकंड के बाद उपयोगकर्ता को होम पेज पर स्वचालित रूप से रीडायरेक्ट करें
    const timer = setTimeout(() => {
      navigate('/', { replace: true }); // होम पेज पर रीडायरेक्ट करें
    }, 3000); // 3000 मिलीसेकंड = 3 सेकंड

    return () => clearTimeout(timer); // कंपोनेंट अनमाउंट होने पर टाइमर साफ़ करें
  }, [navigate]);

  return (
    <div className="auth-container-new mt-5">
    <Container>
      <Row className="justify-content-md-center">
        <Col xs={12} md={4}>
          <Card className="mt-5">
            <Card.Body>
              <Card.Title className="text-center site-color-dark-red h2 mb-4 success">Thank You for Registering</Card.Title>
              
              <div className="text-center mb-4">
                <FontAwesomeIcon icon={faCheckCircle} size="3x" color="green" /> {/* ✅ सफलता आइकन */}
              </div>

              <div className="text-center">
                <p className="mb-3">आपका खाता सफलतापूर्वक सत्यापित हो गया है!</p> {/* ✅ अधिक स्पष्ट संदेश */}
                <p>आपको जल्द ही होम पेज पर रीडायरेक्ट किया जाएगा।</p>
                <Link to="/" className="btn btn-link mt-3">या मैन्युअल रूप से होम पर जाएं</Link> {/* ✅ मैन्युअल नेविगेशन विकल्प */}
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
    </div>
  )
}

export default VerifyOtpSuccess;
